if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a:not(.custom_link)').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if(this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        var currentvalue = event.currentTarget.dataset.value.toLowerCase();
        (async function() {
          const resp = await fetch("https://c.vedix.com/avatars/pixel.png");
          const headers = resp.headers;           
          let country = headers.get("Cloudfront-Viewer-Country").toLowerCase();
          console.log(country,currentvalue);      
          if(country != currentvalue){
            var market_countries = document.querySelector('body').getAttribute("data-countries");                        
            var market_array = market_countries.split(',');
            var country_list = [];
            for(var i  = 0 ; i < market_array.length ; i++){
             country_list.push(market_array[i]) 
            }   
            console.log(currentvalue);
            if(country == 'in' && document.querySelector('body').getAttribute('data-enablindred')){
              location.href = `https://www.plixlife.com?fromRegion=${currentvalue}`;       
              setCookie('redirectOverride',false,-1);
              return false;
            }
            var hascurrent = false;
            if(window.location.origin.includes(currentvalue)){
              hascurrent = true;
            }else if(country_list.indexOf(currentvalue) == -1){
              if(window.location.origin.includes('us.')){
                hascurrent = true;
              }
            }
            if(country == 'gb'){
              country = 'uk';
            }else if(country == 'ae'){
              country = 'uae';
            }else if(country_list.indexOf(country) == -1){
              country = 'us';
            }
            
            var countryup = country.toUpperCase();
            console.log(hascurrent);
            console.log(country);
            //set cookie
            function setCookie(name, value, days) {
                var d = new Date;
                d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
                document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
            }              
            setCookie('redirectOverride',false,-1);
            if(hascurrent){
             location.href = `https://${country}.plixlife.com?redirectOverride=true`;        
            }else{
              location.href = `https://${country}.plixlife.com?fromRegion=${currentvalue}&override=true`;       
            }              
          }
        })();
        // this.elements.input.value = event.currentTarget.dataset.value;
        // if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
